export default "__VITE_ASSET__DyhVysQK__"